'use strict';

angular.module('webAgro1App').factory('LoadGoogleMapsService', function ($q, $window, $timeout) {
  var TIMEOUT_MAP = 15000;
  var API_KEY = 'AIzaSyAKtTIN2iGG4uPUMDGP0gHlUz5FBuWAagI';

  return {
    load: function() {
      var deferred = $q.defer();

      var timer = $timeout(function() {
        deferred.reject('MAPA');
      }, TIMEOUT_MAP);

      function loadScript() {
        var script = document.createElement('script');
        script.src = '//maps.googleapis.com/maps/api/js?libraries=drawing&callback=initMap&key=' + API_KEY;
        document.body.appendChild(script);
      }

      // Script loaded callback, send resolve
      $window.initMap = function () {
        $timeout.cancel(timer);
        loadMarkerWithLabel();
        deferred.resolve();
      };

      loadScript();

      return deferred.promise;
    }
  };
});
